import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import ReserveDetail from "./reserve-detail";

const ReserveDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/reserves');
    }

    return (
        <ReserveDetail id={id} onClose={onClose}/>
    )

});

export default ReserveDetailPage;